export default {
    fund: [{
            "title": "企业境内上市的形式不包括（　　）。",
            "question": "A. 境内首次公开发行上市\nB. 企业的股东以持有的企业股权为对价，认购上市公司定向发行的新股进而实现企业间接上市\nC. 通过收购上市公司控股股东的股权成为上市公司的母公司，进而实现间接上市\nD. 通过与上市公司进行重大资产重组，进而实现间接上市",
            "answer": "B",
            "explain": "境内上市包括境内首次公开发行上市和间接上市。间接上市包括重大资产重组和借壳上市等。重组上市的路径包括：(1)上市公司以非公开发行方式直接向收购方发行股份购买其资产，从而达到重组上市的目的。(2)非上市公司首先通过协议或二级市场购买等方式取得上市公司控制权，非上市公司控制上市公司后，通过上市公司购买非上市公司的资产，将非上市公司的有关业务和资产注入到上市公司中去，从而实现重组上市的目的。认购上市公司定向发行的新股并不能对企业自身进行重组。"
        },
        {
            "title": "股权投资基金托管人的职责不包括（　　）。",
            "question": "A. 开展投资监督\nB. 基金份额登记\nC. 确保基金财产的完整与独立\nD. 对所托管的不同基金财产分别设置账户",
            "answer": "B",
            "explain": "基金托管人对基金资产进行保管并对基金管理人进行监督。具体来说，基金托管人主要履行下列职责："
        },
        {
            "title": "计算基金资产净值时，需要考虑的因素包括（　　）。",
            "questions": "I. 项目公允价值<br>II. 银行存款<br>III. 已支付管理费<br>IV. 基金负债",
            "question": "A. II、III、IV\nB. I、II、III、IV\nC. I、II、IV\nD. I、III、IV",
            "answer": "C",
            "explain": "本题考查基金估值的内容。"
        },
        {
            "title": "以下关于公司型基金基本税负描述错误的是（　　）。",
            "question": "A. 基金的自然人投资者以股息红利形式取得的分配需承担双重征税\nB. 基金的公司投资者以股息红利形式取得的分配需承担双重征税\nC. 基金所投项目若通过并购和回购等非上市股权转让方式退出，不属于增值税征税范围\nD. 基金所投项目上市后通过二级市场退出时需按照税务机关的要求缴纳增值税",
            "answer": "B",
            "explain": "本题考查股权投资基金的基本税负。公司型基金的投资者作为公司股东从公司型基金获得的分配是公司税后利润的分配。"
        },
        {
            "title": "使用创业投资估值法时，股权投资基金需估算（　　）时点的股权价值。",
            "question": "A. 目标公司IPO\nB. 目标公司被并购\nC. 基金存续到期\nD. 目标公司退出",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "募集机构推介股权投资基金前，确定特定对象的程序错误的是（　　）。",
            "question": "A. 邮件确认\nB. 问卷调查\nC. 录音电话\nD. 口头访谈",
            "answer": "D",
            "explain": "本题考查特定对象的确认。"
        }, {
            "title": "根据《私募投资基金监督管理暂行办法》的专业化经营原则，律师在出具法律意见书时需要对申请机构核查的内容有（　　）。",
            "questions": "I. 主营业务是否为股权投资基金管理业务<br>II. 是否兼营可能与股权投资基金业务存在冲突的业务<br>III. 是否兼营与“投资管理”买方业务存在冲突的业务<br>IV. 是否兼营其他非金融业务",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、III、IV\nD. I、II、IV",
            "answer": "C",
            "explain": "本题考查法律意见书的内容。"
        },
        {
            "title": "关于投资协议中的保护性条款，以下说法错误的是（　　）。",
            "question": "A. 目标企业在执行某些可能损害投资人利益或对投资人利益有重大影响的行为或交易前，应事先获得投资人的同意\nB. 保护性条款实际上赋予了股权投资基金对一些特定重大事项的否决权\nC. 保护性条款是为保护股权投资基金利益而进行的安排\nD. 确保不会因目标企业以更低的发行价进行新一轮融资而导致投资人的股权被稀释",
            "answer": "D",
            "explain": "A选项说法正确，保护性条款是指股权投资基金为保护自身利益而设置的要求目标公司在执行损害投资者利益或对投资者利益有重大影响的行为时，需取得投资者同意的条款。"
        },
        {
            "title": "在全国中小企业股份转让系统挂牌的公司股票解除转让限制，应由挂牌公司向主办券商提出，由主办券商报告全国股份转让系统公司备案，全国股份转让系统公司备案确认后，通知（　　）办理解除限售登记。",
            "question": "A. 中国证监会\nB. 中国证监会地方派出机构\nC. 挂牌公司董事会\nD. 中国证券登记结算有限责任公司",
            "answer": "D",
            "explain": "A、B选项不符合题意，中国证监会及其派出机构是我国股权投资基金的监管机构，依法对股权投资基金业务活动实施监督管理，不负责办理解除限售登记。"
        },
        {
            "title": "股权投资基金管理人违反法律、行政法规、行政规章的规定，中国证监会及其派出机构可以对其采取的行政监管措施有（　　）。",
            "questions": "I. 责令改正<br>II. 监管谈话<br>III. 公开谴责<br>IV. 行政警告",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. II、III、IV\nD. I、II、IV",
            "answer": "A",
            "explain": "本题考查政府管理的行政监管措施。"
        },
        {
            "title": "基金管理机构对被投企业的运作进行一定的跟踪与监控，实施投资风险管理，也会以各种方式向被投资企业提供增值服务，帮助被投企业成长和发展，这属于股权投资基金运作流程的（　　）。",
            "question": "A. 投资阶段\nB. 投后管理阶段\nC. 募集阶段\nD. 退出阶段",
            "answer": "B",
            "explain": "本题考查投资后管理阶段的主要工作。"
        },
        {
            "title": "引起股权投资基金所有者权益变动的是（　　）。",
            "questions": "I. 投资人缴付出资<br>II. 基金进行收益分配<br>III. 基金向普通合伙人支付业绩报酬<br>IV. 基金有限合伙人向第三方转让其在基金中的份额",
            "question": "A. I、II、III\nB. II、IV\nC. I、II、III、IV\nD. I、III",
            "answer": "B",
            "explain": "新的投资者参与（IV项）、老的投资者退出以及基金收益分配（II项）等会引起股权投资基金所有者权益变动，应当进行所有者权益核算。"
        }, {
            "title": "对于股权投资基金市场、基金市场主体及其活动的监督管理，广义的股权投资基金监管主体包括（　　）。",
            "questions": "I. 政府监管机构<br>II. 行业自律组织<br>III. 基金机构内部监督部门<br>IV. 社会力量",
            "question": "A. I、II\nB. I、III\nC. II、III\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查广义的股权投资基金监管。"
        },
        {
            "title": "关于拖售权条款，表述正确的是（　　）。",
            "question": "A. 拖售权条款通常与第一拒绝权条款同时出现\nB. 拖售权是指目标公司的其他股东敌对外出售股权时，股权投资基金有权以其持股比例为基础，以同等条件要求参与该出售交易\nC. 拖售权是指在接受第三方股权收购要约，有权要求其他股东按照基金与第三方协商确定的出售条件和价格，一起向该第三方出售\nD. 相比拖售权，随售权赋予股权投资基金更大的权利，使其即使作为少数股东也可以享有大股东的权利",
            "answer": "C",
            "explain": "A、B选项表述错误，随售权条款通常与第一拒绝权条款同时出现。随售权又称共同出售权，是指目标公司的其他股东欲对外出售股权时，股权投资基金有权以其持股比例为基础，以同等条件参与该出售交易。第一拒绝权，是指目标公司的其他股东被对外出售股权时，作为大股东的股权投资基金在同等条件下有优先购买权。C选项表述正确，拖售权条款是说如果有第三方向股权投资基金发出股权收购要约，且股权投资基金接受该要约，则其有权要求其他股东一起按照相同的出售条件和价格向该第三方转让股权。"
        },
        {
            "title": "关于基金业绩评价，下面说法正确的是（　　）。",
            "question": "A. 已分配收益倍数是站在投资者的角度来评价股权投资基金\nB. 已分配收益倍数体现了投资者的账面回报水平\nC. 净内部收益率是从项目层面反映投资基金的回报水平\nD. 总收益倍数体现了投资者现金的回收情况",
            "answer": "A",
            "explain": "A选项说法正确，B选项说法错误，已分配收益倍数（DPI）是指截至某一特定时点，投资者已从基金获得的分配金额总和与投资者已向基金缴款金额总和的比率，体现了投资者现金的回收情况。"
        },
        {
            "title": "某有限合伙型股权投资基金的合伙人包括：(1)自然人甲；(2)有限合伙企业A，已在中国证券投资基金业协会备案为私募基金，A的合伙人包括两名自然人（乙和丙）和一家有限责任公司B（其唯一股东为自然人丁）；及(3)有限责任公司C，其股东为两名自然人（戊和己）。前述所有自然人和实体均满足合格投资者标准，对该基金的合伙人适用穿透规则后，最终投资者总数为（　　）。",
            "question": "A. 3\nB. 5\nC. 4\nD. 6",
            "answer": "B",
            "explain": "本题考查合格投资者人数的核查。(1)自然人算作1个合伙人。(2)以合伙企业等非法人形式投资于股权投资基金的，应当穿透核查最终投资者是否为合格投资者，并合并计算投资者人数。需要穿透核查，算作3个合伙人。"
        },
        {
            "title": "以下投资行为属于天使投资的是（　　）。",
            "question": "A. 某互联网公司的老板使用公司资金投资某创新环保企业\nB. 某互联网公司老板使用自有资金投资某股权投资基金，并通过该股权投资基金投资某创新环保企业\nC. 某互联网公司老板使用自有资金投资其名下公司的附属企业\nD. 某互联网公司的老板使用自有资金投资某创新环保企业",
            "answer": "D",
            "explain": "本题考查天使投资的定义。D选项符合题意，天使投资是指除被投资企业职员及其家庭成员和直系亲属以外的个人以其自有资金直接开展的创业投资活动，属于非组织化的创业投资范畴。"
        },
        {
            "title": "关于竞业禁止条款，以下表述错误的是（　　）。",
            "question": "A. 我国《公司法》明确规定，未经董事会同意，公司董事和高级管理人员不得自营或者为他人经营与所任职同类的业务\nB. 竞业禁止条款的目的是保证目标公司的利益不受损害，从而保障投资者的利益\nC. 竞业禁止主要包括法定竞业禁止和约定竞业禁止两种形式\nD. 在实践中，目标公司的创始人股东、高级管理人员以及其他关键人员通常需要签署竞业禁止协议",
            "answer": "A",
            "explain": "本题考查竞业禁止条款。A选项说法错误，我国《公司法》明确规定，未经股东会或者股东大会同意（而不是董事会），公司董事和高级管理人员不得自营或者为他人经营与所任职公司同类的业务。"
        }, {
            "title": "股权投资基金投资阶段的环节包括（　　）。",
            "questions": "I. 尽职调查<br>II. 跟踪与监控<br>III. 立项<br>IV. 投资交割",
            "question": "A. I、II、IV\nB. I、II、III\nC. I、III、IV\nD. II、III、IV",
            "answer": "C",
            "explain": "本题考查股权投资基金的运作阶段。II、III、IV项符合题意，投资阶段主要包括项目开发与初审、立项、签署投资备忘录、尽职调查、投资决策、签订投资协议、投资交割等环节。"
        },
        {
            "title": "关于股权投资基金运行期间向投资者披露信息，以下表述符合规定的是（　　）。",
            "question": "A. 股权投资基金变更托管银行，基金的信息披露义务人不需要向投资者披露\nB. 股权投资基金运行期间，应当每周向投资者披露基金投资项目\nC. 股权投资基金正常运行期间，基金的信息披露义务人可以不向投资者披露基金投资项目\nD. 股权投资基金管理人应在基金合同中约定向投资者披露基金投资、投资收益分配、基金承担的费用和业绩报酬等信息",
            "answer": "D",
            "explain": "本题考查向投资者信息披露的主要事项。A选项说法错误，股权投资基金变更托管银行属于重大事项，信息披露义务人应当按照基金合同的约定在10个工作日内及时向投资者披露。B、C选项说法错误，股权投资基金正常运行期间需要定期披露，定期披露分为季度披露和年度披露，不需每周向投资者披露基金投资项目。D选项说法正确，信息披露义务人应当在每年结束之日起4个月以内向投资者披露报告期未基金净值和基金份额总额、基金的财务情况、基金投资运作。"
        },
        {
            "title": "关于董事会席位条款，以下表述错误的是（　　）。",
            "question": "A. 董事会席位条款会约定董事会的席位构成\nB. 在未获得董事会席位的情况下，股权投资基金委派的观察员通常具有投票权\nC. 董事会席位条款通常会约定董事会席位分配规则\nD. 董事会席位条款通常会约定董事会席位总数",
            "answer": "B",
            "explain": "本题考查董事会席位条款。A选项说法正确，董事会席位条款是指在投资协议中股权投资基金和目标公司之间约定董事会的席位构成和分配的条款。B选项说法错误，在未获得董事会席位的情况下，股权投资基金会希望委派人员出任董事会“观察员”角色，观察员通常不具有投票权，也不承担决策的作用，只是作为帮助投资人更好地了解公司日常运营情况的辅助性角色。"
        },
        {
            "title": "某基金成立于2012年，收到投资者出资合计人民币10亿元，分别投资了4个项目。A项目投资成本4亿元，于2016年上市后二级市场转让共获价款10亿元。B项目投资成本2亿元，于2015年股权转让给其他投资者获得价款8亿元，C项目投资成本3亿元，于2017年向管理层出售股权获2亿元。截至2017年12月31日，该基金仍持有D项目，D项目投资成本1亿元，公允价值2亿元，假设不考虑其他税费，基金管理人将投资处置额分配给投资者，于2017年12月31日该基金的总收益倍数为（　　）。",
            "question": "A. 2.75\nB. 3\nC. 2.2\nD. 2",
            "answer": "C",
            "explain": "本题考查总收益倍数的内容。总收益倍数（TVPI）是指截至某一特定时点，投资人已从基金获得的分配金额加上资产净值（NAV）与投资人已向基金缴款金额总和的比率。"
        },
        {
            "title": "关于股权投资基金选择第三方基金销售机构（代销机构）进行委托募集，合格代销机构的要求是（　　）。",
            "questions": "I. 代销机构是需要有代销意愿的基金管理人<br>II. 代销机构需遵循募集行为管理办法的规定<br>III. 代销机构应具有基金销售资质<br>IV. 代销机构需成为中国证券投资基金业协会会员",
            "question": "A. I、II、III、IV\nB. I、II、III\nC. II、III、IV\nD. I、II",
            "answer": "C",
            "explain": "本题考查委托募集的相关规定。I项说法错误，代销机构主要是有资格的第三方基金销售机构。"
        },
        {
            "title": "关于已分配收益倍数，以下表述正确的是（　　）。",
            "questions": "I. 已分配收益倍数是指截至某一特定时点，投资者从基金获得的分配金额总和与投资者已向基金缴款金额总和的比率<br>II. 已分配收益倍数是指截至某一特定时点，投资者从基金获得的分配金额加上资产净值与投资者已向基金缴款金额总和的比率<br>III. 已分配收益倍数体现了投资者的账面回报水平<br>IV. 已分配收益倍数体现了投资者现金的回收情况",
            "question": "A. I、IV\nB. II、IV\nC. I、III\nD. II、III",
            "answer": "A",
            "explain": "本题考查已分配收益倍数的定义。I、IV项描述正确，已分配收益倍数（DPI）是指截至某一特定时点，投资者已从基金获得的分配金额总和与投资者已向基金缴款金额总和的比率，体现了投资者现金的回收情况。"
        }, {
            "title": "关于公司型基金所得税，以下表述正确的是（　　）。",
            "questions": "I. 符合条件的居民企业之间的股息、红利等权益性投资收益为所得税免税收入<br>II. 以债转股等方式投资时，可能存在利息收入，是基金应税收入的组成部分<br>III. 自然人获得公司型基金税后利润分配需自行缴纳税息红利所得<br>IV. 公司型基金的税收原则是“先税后分”",
            "question": "A. I、III\nB. II、III、IV\nC. I、II、IV\nD. I、II、III、IV",
            "answer": "C",
            "explain": "本题考查公司型基金所得税内容。I项说法正确，《企业所得税法》规定符合条件的居民企业之间的股息、红利等权益性投资收益为免税收入，可以在计算应纳税所得额时减除。"
        },
        {
            "title": "某合伙型股权投资基金的基金合同中包含如下条款，其中不符合中国证券投资基金业协会相关基金合同要求的是（　　）。",
            "question": "A. 本基金由普通合伙人担任执行事务合伙人，执行事务合伙人有权对合伙企业的财产进行投资、管理、运用和处置，并接受其他普通合伙人和有限合伙人的监督\nB. 本基金的财产份额不得以任何方式公开募集或发行\nC. 本基金解散清算时首先应对基金合伙人进行分配，如有剩余，则可用于支付基金清算费用\nD. 本基金为有限合伙企业形式，仅有一名普通合伙人",
            "answer": "C",
            "explain": "本题考查合伙型基金。A选项符合要求，合伙型股权投资基金合伙协议应约定由普通合伙人担任执行事务合伙人。普通合伙人对基金(合伙企业)债务承担无限连带责任，负责合伙事务的执行。执行事务合伙人有权对合伙企业的财产进行投资、管理、运用和处置，并接受其他普通合伙人和有限合伙人的监督。B选项符合要求，合伙企业不得以任何方式公开募集和发行基金，亦不得为被投资企业以外的企业提供担保。"
        },
        {
            "title": "投资机构可以协助被投资企业建立规范的财务管理体系，这一体系的基本准则不包括（　　）。",
            "question": "A. 降低成本\nB. 风险管理\nC. 全面预算\nD. 规范管理",
            "answer": "A",
            "explain": "本题考查增值服务的主要内容。被投资企业，尤其是早期创业企业，在财务管理上往往缺乏规范严谨的财务管理理念、管理能力与高水平的管理人员，监管制度也往往不够完善。B、C、D选项为财务管理体系的基本原则，投资机构在财务管理体系建立方案具备专业的经验与能力，也可以协助引入具有较高水平的财务管理人员，帮助被投资企业建立起以“规范管理、风险控制和全面预算”为基本准则的现代财务管理体系。A选项不是财务管理体系的基本原则，建立规范的财务管理体系是为了财务管理体系更完善，不是为了降低成本。"
        },
        {
            "title": "关于相对估值法的估值倍数公式，下列选项表述错误的是（　　）。",
            "question": "A. 市净率倍数=公司价值/净资产\nB. 市销率倍数=股权价值/销售收入\nC. 市盈率倍数=股权价值/净利润\nD. 市盈率倍数=每股价值/每股收益",
            "answer": "A",
            "explain": "本题考查相对估值法的概念。相对估值法的基本原理是以可比公司的价格为基础，来评估目标公司的相应价值，评估所得的价值，可以是股权价值，也可以是企业价值。相对估值法的计算公式为：目标公司价值=目标公司某种指标×(可比公司价值/可比公司某种指标) 市盈率倍数=股权价值/净利润=每股价值/每股收益；市净率倍数=股权价值/净资产=每股价值/每股净资产；市销率倍数=股权价值/销售收入=每股价值/每股销售收入。"
        },
        {
            "title": "可以从事股权投资基金募集行为的合格主体包括（　　）。",
            "questions": "I. 在中国证券投资基金业协会办理股权基金管理人登记的机构<br>II. 在中国证券投资基金业协会办理证券基金管理人<br>III. 在中国证券投资基金业协会注册取得基金销售资格并成为基金业协会会员的机构<br>IV. 在中国证监会注册取得基金销售资格并成为中国证券投资基金业协会会员的机构",
            "question": "A. II、IV\nB. I、II、IV\nC. I、IV\nD. I、II、III",
            "answer": "C",
            "explain": "本题考查合法的募集主体。从募集主体机构的角度看，基金募集分为自行募集和委托募集。"
        },
        {
            "title": "股权投资基金与目标公司签订投资协议和投资备忘录时，关于优先认购权条款，以下表述正确的是（　　）。",
            "question": "A. 目标企业的其他股东欲对外出售股权时，股权投资基金有权按一定原则参与该出售交易\nB. 目标企业发行新股或可转换债券时，作为老股东的股权投资基金可以按照比例优先于新进投资人进行认购\nC. 赋予了股权投资基金对一些特定重大事项的一票否决权\nD. 目标企业在与股权投资基金进行谈判过程中不得再与其他投资机构接触",
            "answer": "B",
            "explain": "本题考查优先认购权条款的定义。A选项表述错误，该选项表述的是随售权条款，是指目标公司的其他股东欲对外出售股权时，股权投资基金有权以其持股比例为基础，以同等条件参与该出售交易。B选项表述正确，优先认购权，是指目标公司未来发行新的股份或者可转换债券时，股权投资基金将按其持股比例获得同等条件下的优先认购权利。"
        }, {
            "title": "小吴拟向某私募基金进行投资，小吴下述行为不符合法律规定的是（　　）。",
            "question": "A. 向亲朋好友募集人民币100万元以甲的名义向私募基金投资，待收益分配时按照各自出资比例分配给各出资人\nB. 签字确认由私募基金管理人制作的风险揭示书\nC. 如实填写风险识别能力和承担能力问卷\nD. 向私募基金管理人书面确认自己符合合格投资者要求",
            "answer": "A",
            "explain": "本题考查募集行为管理的内容。A选项行为错误，股权投资基金应当向合格投资者募集，单位或个人不得为规避合格投资者标准，募集以股权投资基金份额或其收益权为投资标的的金融产品，或者将股权投资基金份额或其收益权进行非法拆分转让，全额突破合格投资者标准，股权投资基金管理人自行销售股权投资基金的。"
        },
        {
            "title": "基金信息披露义务人在进行信息披露时，通常按照股权投资基金所处生命周期不同阶段，披露不同的基金信息，以下不属于基金运作期间的信息披露内容的是（　　）。",
            "question": "A. 基金会计数据和财务指标\nB. 基金的基本信息\nC. 基金承诺收益\nD. 重大关联交易",
            "answer": "C",
            "explain": "本题考查信息披露的内容。在基金运作期间：(1)定期披露：信息披露义务人应当将基金报告期间的投资、运作情况，以定期报告的形式，向投资者进行信息披露。基金的定期报告通常包含以下内容：基金的基本信息、基金当事人以及相关服务机构的信息、基金已投资项目的基本情况、项目退出情况、基金会计数据和财务指标、利润分配情况、承担的费用情况、基金管理人报告信息等内容。(A、B选项不符合题意)"
        },
        {
            "title": "关于基金服务业务的委托关系与服务主体，以下表述正确的是（　　）。",
            "question": "A. 基金服务机构接受投资者的委托，为投资者提供服务\nB. 基金服务机构接受投资者的委托，为股权投资基金提供服务\nC. 基金服务机构接受管理人的委托，为股权投资基金提供服务\nD. 基金服务机构接受管理人的委托，为管理人提供服务",
            "answer": "C",
            "explain": "本题考查基金服务业务的内容。股权投资基金管理人委托私募基金服务机构，为股权投资基金提供基金募集、投资顾问、份额登记、估值核算、信息技术系统等服务业务。"
        },
        {
            "title": "股权投资基金宣传推荐资料登载过往业绩的，一般应遵循（　　）。",
            "questions": "I. 基金合同已经生效一段时间，如6个月以上<br>II. 应登载完整的业绩记录<br>III. 无需声明过往业绩并不代表未来表现<br>IV. 如基金存续时间较长，可登载近几年的完整、连续业绩，如近5年完整的业绩记录",
            "question": "A. I、II、III\nB. I、III、IV\nC. II、III、IV\nD. I、II、III、IV",
            "answer": "B",
            "explain": "本题考查宣传推介材料登载基金过往业绩的要求。"
        },
        {
            "title": "清算价值法是假设企业破产和公司清算时，将企业拆分为可出售的几个业务或资产包，并分别估算这些业务或资产包的（　　），加总后作为企业估值的参考标准。",
            "question": "A. 评估价值\nB. 变现价值\nC. 账面价值\nD. 重置成本",
            "answer": "B",
            "explain": "本题考查清算价值法的主要方法。B选项符合题意，清算价值法的估值原理是假设企业破产和公司清算时，将企业拆分为可出售的几个业务或资产包，并分别估算这些业务或资产包的变现价值，加总后作为企业估值的参考标准。"
        },
        {
            "title": "中国证监会对股权投资基金的调查手段，不包括以下哪一项（　　）。",
            "question": "A. 封存可能被转移、藏匿或者损毁的文件和资料\nB. 现场检查\nC. 刑事拘留\nD. 调查高管个人证券账户",
            "answer": "C",
            "explain": "本题考查中国证监会事中事后监管的措施。根据《证券投资基金法》及相关配套规范的授权，中国证监会在对股权投资基金进行事中事后监管时，有权采取以下措施：(1)进行现场检查，并要求报送有关的业务资料；(包括B选项)(2)进入涉嫌违法行为发生场所调查取证；"
        }, {
            "title": "某股权投资基金A于2011年7月投资了B公司，投资协议中包含保密条款且保密期限为5年，B公司于2016年1月递交了IPO申请，下述哪一项行为可能违反了双方约定的保密义务（　　）。",
            "question": "A. 2017年1月基金A向其基金出资人提供了B公司近三年业务发展情况\nB. 2016年6月基金A向其基金潜在投资人介绍了B公司IPO进展\nC. 2015年2月基金A向B公司的保存机构提供了基金出资人相关信息\nD. 2015年3月B公司向其次轮潜在投资人提供了基金A投资时的投资估值意见及投资协议",
            "answer": "D",
            "explain": "本题考查保密条款的内容。保密条款是指除依法律或监管机构要求的信息披露外，投融资双方对在股权投资交易中知悉的对方商业秘密承担保密义务，未经对方书面同意，不得向第三方泄露。保密是股权投资基金和目标公司双方共同的义务。"
        },
        {
            "title": "有关排他性条款中的排他期表述正确的是（　　）。",
            "question": "A. 排他期根据业界最常用公式计算得出\nB. 排他期由目标公司与股权投资基金双方协商一致后约定\nC. 排他期由目标公司根据自身需求安排决定\nD. 排他期由股权投资基金对目标公司提出并实施",
            "answer": "B",
            "explain": "本题考查排他性条款。排他性条款的排他期由双方约定，通常为几个月。排他性条款要求目标企业现任股东及其任何任职职员、董事、财务顾问、经纪人或代表公司行事的人在约定的排他期内不得与其他投资机构进行接触，从而保证双方的时间和经济效率。"
        },
        {
            "title": "股权投资基金通过基金管理人参与被投资企业股东（大）会，股权投资基金应拥有当然与资格的是（　　）。",
            "question": "A. 股东（大）会和董事会\nB. 董事会\nC. 监事会\nD. 股东（大）会",
            "answer": "D",
            "explain": "本题考查投资后管理阶段获取信息的主要方式。投后管理阶段，基金管理人可以通过参加被投资企业股东大会（股东会）、董事会、监事会全面了解小公司发展状况的重要信息，并通过行使相应权利促进被投资企业的良性发展，并保护投资机构的利益。股权投资基金是被投资企业的股东，所以一定可以参与股东（大）会，不需要其他条件，所以股权投资基金拥有当然参会资格的是股东大会。"
        },
        {
            "title": "关于相对估值法，表述错误的是（　　）。",
            "question": "A. 计算适用于目标公司的可比倍数时，通常用若干个可比公司可比倍数的平均值或中位数作为目标公司的倍数参考值，还需注意剔除其中的异常值\nB. 根据目标公司与可比公司的特点进行比较分析，可以在可比公司可比倍数的平均值或中位数的基础上进行调整，进而计算出适用于目标公司的可比倍数\nC. 股权投资基金可以根据目标公司的特点选取适用的估值倍数，但考虑到估值倍数的可靠性及可比性，选取的估值倍数必须是以客观的（如息税前利润、净利润、销售收入、净资产等）计算的估值倍数，而非其他业务指标或数据\nD. 相对估值法受可比公司企业价值偏差影响，且其分析结果的可靠性受可比公司质量的影响",
            "answer": "C",
            "explain": "本题考查相对估值法的内容。C选项说法错误，根据目标公司的特点，股权投资基金选择合适的估值指标，并计算可比公司的估值倍数。常用的估值指标有市盈率倍数、企业价值/息税前利润倍数、企业价值/息税折旧摊销前利润倍数、市净率倍数、市销率倍数等。如果目标公司和可比公司属于某一特殊行业，还可使用符合行业特点的估值倍数。"
        },
        {
            "title": "下列关于基金管理人登记的说法错误的是（　　）。",
            "question": "A. 公司的基金管理人基本情况包括基金管理人的登记时间、主要负责人等基本信息以及基本诚信信息\nB. 登记申请材料完备的，中国投资基金业协会会通过出具私募基金管理人纸质证明的方式，为基金管理人办理登记手续\nC. 基金管理人进行登记主要通过中国证券投资基金业协会的资产管理业务综合报送平台提交相关资料或信息\nD. 经营记后的基金管理人依法解散的，中国证券投资基金业协会应当及时注销基金管理人登记",
            "answer": "B",
            "explain": "本题考查登记与备案的方式。A选项说法正确，网站公示的基金管理人基本情况包括：基金管理人的名称、成立时间、登记时间、住所、联系方式、主要负责人等基本信息以及基本诚信信息。B选项说法错误，基金管理人提交的登记申请材料完备的，基金业协会应该自收齐登记材料之日起20个工作日内，以通过网站公示基金管理人基本情况的方式，为基金管理人办结登记手续。"
        },
        {
            "title": "股权投资基金尽职调查的核心内容为（　　）。",
            "question": "A. 法律尽调\nB. 风险控制\nC. 财务尽调\nD. 业务尽调",
            "answer": "D",
            "explain": "本题考查业务尽职调查的地位。A选项表述错误，法律尽职调查的作用是帮助股权投资基金全面评估企业资产和业务的合法性以及潜在的法律风险，从功能角度来看，法律尽职调查更多的是定位于风险发现，而非价值发现。B选项表述错误，尽职调查的主要内容为业务尽调调查，财务尽职调查和法律尽职调查，不包括风险控制。"
        }, {
            "title": "关于基金管理人在中国证券投资基金业协会登记时的业务范围问题，以下说法错误的是（　　）。",
            "question": "A. 在管理人登记法律意见书中，律师需要对股权投资基金类管理人从事“投资咨询”业务进行申请调查和论证说明\nB. 对于兼营保理、担保、房地产开发、交易平台等业务的申请机构，需要提前进行业务剥离\nC. 股权投资基金类管理人的“投资咨询”业务的实际经营范围可以存在《证券、期货投资咨询管理暂行办法》规定的“证券、期货投资咨询”业务\nD. 对于兼营民间借贷、民间融资、配资业务、小额理财、小额借贷、P2P/P2B、众筹等业务的申请机构，需要提供进行业务剥离",
            "answer": "C",
            "explain": "本题考查法律意见书的内容。A选项说法正确，C选项说法错误，法律意见书中律师应重点核查的内容包括私募证券投资基金类管理人不得兼营“投资咨询”业务。私募股权投资基金类管理人，需要对“投资咨询”业务进行申请调查和论证说明。“投资咨询”业务的实际经营范围不得存在《证券、期货投资咨询管理暂行办法》中规定的“证券、期货投资咨询”业务。B、D选项说法正确，对于兼营网同借贷、网间融资、配资业务、小额理财、小额借贷、P2P/P2B、众筹、保理、担保、房地产开发、交易平台等业务的申请机构，需要提前进行业务剥离，业务重组完成后再出具法律意见书。"
        },
        {
            "title": "关于公司型股权投资基金登记，以下表述错误的是（　　）。",
            "question": "A. 公司型股权投资基金设立，应向中国证券投资基金业协会办理工商登记手续\nB. 公司型股权投资基金增资，应向工商行政管理机关办理变更登记手续\nC. 股份有限公司型股权投资基金除发起人以外的股东发生变更的，无需向工商行政管理机关办理登记手续\nD. 公司型股权投资基金终止清算，应向工商行政管理机关办理注销手续",
            "answer": "A",
            "explain": "本题考查公司型股权投资基金登记。A选项说法错误。公司型股权投资基金设立，应向工商行政管理机关办理注册登记手续。而不是向中国证券投资基金业协会办理。B、D选项说法正确，公司型股权投资基金增资、减资、股权/股份转让、收益分配以及终止清算的，应向工商行政管理机关办理工商变更登记、注销手续。C选项说法正确，股份有限公司型股权投资基金除发起人以外的股东发生变更的，因为不影响法人财产权，所以无须向工商行政管理机关办理登记手续。"
        },
        {
            "title": "关于股权投资基金监管，以下表述错误的是（　　）。",
            "question": "A. 股权投资基金监督机构的监管对象包括基金管理人及各类市场服务机构\nB. 存在较高的风险外溢性，对金融系统稳定存在威胁，使群防范系统性金融风险成为股权投资基金监管目标之一\nC. 从适度监管原则的角度，政府监管不应直接干预基金机构内部的经营管理\nD. 维护监管机构的权威性是股权投资基金监管的首要目标，也是实现依法监管和高效监管的基础",
            "answer": "D",
            "explain": "本题考查股权投资基金监管内容。A选项说法正确，中国证监会及其派出机构是我国股权投资基金的监管机构，依法对基金管理人和市场服务机构开展股权投资基金业务实施监督管理，对违法违规行为进行查处。B选项说法正确，股权投资基金存在较高的风险外溢性，对金融系统稳定存在威胁，使得防范系统性金融风险成为股权投资基金监管目标之一。C选项说法正确，从适度监管原则的角度，政府监管不应直接干预基金机构内部的经营管理，监管范围应严格限定在基金市场失灵的领域。D选项说法错误，保护基金投资者合法权益是股权投资基金监管的首要目标，是股权投资基金行业赖以存在和发展的基础。"
        },
        {
            "title": "股权投资基金募集流程通常不包括（　　）。",
            "question": "A. 投资者确认\nB. 储备项目收集\nC. 基金路演\nD. 协议签署及出资",
            "answer": "B",
            "explain": "本题考查股权投资基金的募集流程。股权投资基金募集的一般流程主要包括：募集筹备期、基金路演期（C项）、投资者确认（A项）、协议签署及出资（D项），故本题选择B选项。"
        },
        {
            "title": "以下属于股权投资基金募集期间与投资者互动的重点内容的是（　　）。",
            "question": "A. 基金管理人向投资人详细介绍投资策略、历史业绩以及基金合同主要条款等\nB. 基金管理人回应投资人针对特定项目退出分配的代扣代缴税金的计算\nC. 基金管理人向投资人披露托管机构变更情况\nD. 基金管理人召开合伙人大会，向投资者介绍基金投资策略，投资机会和进展、已投项目公司的经营情况以及基金财务状况等",
            "answer": "A",
            "explain": "本题考查各阶段与投资者互动的重点。选项A，属于【帮助投资者充分理解股权投资基金的协议约定】和【帮助投资者对基金管理人进行充分调研】的内容。"
        }, {
            "title": "下列对股权投资基金的基本要求，正确的是（　　）。",
            "question": "A. 股权投资基金的闲置资金一般只能存放银行、购买国债或其他固定收益类的证券\nB. 股权投资基金财产可以向他人提供贷款\nC. 股权投资基金不得投资二级市场公开交易的股票，所以股权投资基金投资的未上市企业上市后，其持有的股份必须转让\nD. 广义创业投资基金和广义股权投资基金是不等同的概念",
            "answer": "A",
            "explain": "本题考查对股权投资基金的基本要求。A选项说法正确，股权投资基金的闲置资金一般只能存放银行，购买国债或其他固定收益类的证券。B选项说法错误，股权投资基金财产不得违规向他人贷款或者提供担保。C选项说法错误，从专业化运营角度看，通常股权投资基金不得投资二级市场公开交易的股票，但是所投资的未上市企业上市后，股权投资基金所持有的股份可以依法流通。D选项说法错误，广义创业投资基金和广义股权投资基金是不等同的概念。"
        },
        {
            "title": "可以担任有限合伙型股权投资基金普通合伙人的是（　　）。",
            "question": "A. 国有独资公司\nB. 中外合资公司\nC. 上市公司\nD. 国有企业",
            "answer": "B",
            "explain": "本题考查普通合伙人的要求。《合伙企业法》第3条规定，“国有独资公司、国有企业、上市公司以及公益性的事业单位、社会团体不得成为普通合伙人”。A、C、D选项均不得成为普通合伙人。"
        },
        {
            "title": "关于估值调整条款，表述错误的是（　　）。",
            "question": "A. 估值调整条款的触发条件是指目标公司的实际业绩已达到事先约定的业绩目标\nB. 估值调整条款通常约定，在一定期限之后如果企业未能完成一定指标，将对投资者按规定进行补偿\nC. 估值主要依据公司当时的经营业绩以及对未来经营业绩的预测做出，具有一定的风险性\nD. 估值调整条款的主要目的是用来弥补投资者因企业实际价值降低而蒙受的损失",
            "answer": "A",
            "explain": "本题考查估值调整条款的内容。A选项说法错误，估值调整机制的触发条件包括目标公司的实际业绩未达到事先约定的业绩目标;发生特定事件(如公司未在约定时间前实现IPO、原大股东失去控股地位、高管严重违反约定等)。"
        },
        {
            "title": "并购投资基金的自有资金和外部资金的比例，通常取决于（　　）。",
            "questions": "I. 目标公司预计现金流<br>II. 外部资金融资成本<br>III. 基金管理人历史投资业绩<br>IV. 资本结构风险",
            "question": "A. I、III、IV\nB. I、II、III\nC. I、II、IV\nD. II、III、IV",
            "answer": "C",
            "explain": "本题考查收购方的自有资金和外部资金比例的决定因素。"
        },
        {
            "title": "股权投资基金A拟投资公司B，在投资协议中约定由公司B总经理在满足相同对基金A的报资进行回购，该回购行为属于（　　）。",
            "question": "A. 控股股东回购\nB. 参股股东\nC. 管理层回购\nD. 员工收购",
            "answer": "C",
            "explain": "本题考查管理层回购。C选项符合题意，管理层回购是指被投资企业的管理层在回购条件满足时自筹资金回购股权投资基金所持有的股权（股份），从而实现股权投资基金的退出。"
        },
        {
            "title": "当投资者的投资规模不能达到某大型基金的投资门槛时，投资者可以借助（　　）间接投资该大型基金。",
            "question": "A. 成长型基金\nB. 基金债权融资\nC. 政府引导基金\nD. 股权投资母基金",
            "answer": "D",
            "explain": "本题考查股权投资母基金的作用。A选项不符合题意，成长型基金亦称“长期成长型基金”，是重视资金长期成长的投资基金。这种基金，为达到资金长期成长的投资目标，一般投资于信誉好、长期有盈利的公司，或者有长期或长期前景的公司。"
        }, {
            "title": "关于投资后管理的作用，以下表述错误的是（　　）。",
            "question": "A. 通过提供增值服务，提升被投资企业自身价值\nB. 通过项目跟踪与管控，发现潜在投资项目的投资价值\nC. 通过提供增值服务，协助被投资企业利用资本市场\nD. 通过项目跟踪与管控，管理和防范投资风险",
            "answer": "B",
            "explain": "本题考查投资后管理的作用。A、C、D选项表述正确，投资后管理的作用包括："
        },
        {
            "title": "关于股权投资基金的清算退出流程，以下表述错误的是（　　）。",
            "question": "A. 基金存续期限届满且公司或全体合伙人决定不再经营的，应当安排清算\nB. 清算过程中的剩余财产应该先支付税费然后向投资人分配\nC. 所有投资项目都实现到期退出的，应当安排基金清算\nD. 无论是公司型、合伙型、还是信托（契约）型股权投资基金，都应该及时向工商机关办理注销手续",
            "answer": "D",
            "explain": "本题考查股权投资基金的清算退出流程。"
        },
        {
            "title": "下列行为中，应被认定为我国刑法第179条规定的擅自发行股票、公司、企业债券的是（　　）。",
            "questions": "I. 某股权众筹平台通过转让股权的方式，累计向其100名实名注册会员进行融资<br>II. 未经依法核准擅自发行基金份额募集基金，情节严重的<br>III. 明知他人从事擅自发行股票、债券等犯罪活动，仍为其提供广告等宣传<br>IV. 未经有关部门批准，向社会不特定对象以转让股权等方式变相发行股票",
            "question": "A. III、IV\nB. I、II、III、IV\nC. I、II、III\nD. II、IV",
            "answer": "A",
            "explain": "本题考查擅自发行股票或者公司、企业债券罪。"
        },
        {
            "title": "关于我国股权投资基金的募集方式，表述正确的是（　　）。",
            "question": "A. 现阶段我国不允许进行公开募集\nB. 获得中国证监会及中国证券投资基金业协会批准后可进行公开募集\nC. 获得中国证监会批准后可进行公开募集\nD. 获得中国证券投资基金业协会批准后可进行公开募集",
            "answer": "A",
            "explain": "本题考查我国股权投资基金的募集方式。在我国，目前不允许进行股权投资基金的公开募集。"
        },
        {
            "title": "关于股权投资基金募集过程中特定对象确定的说法，下列表述错误的是（　　）。",
            "question": "A. 募集机构应当采取问卷调查等方式履行特定对象确定程序\nB. 要先经过特定对象确定程序，才能宣传推介股权投资基金\nC. 募集机构进行线上募集不需要履行特定对象确定程序\nD. 特定对象确定流程要求投资者书面承诺其符合合格投资者标准",
            "answer": "C",
            "explain": "本题考查股权投资基金募集程序中特定对象的确定。"
        },
        {
            "title": "股权投资基金《风险揭示书》中有如下一项风险揭示“本基金可能存在不能满足成立条件从而无法成立的风险，对此，基金管理人承担责任的方式为：/(1)以其固有财产承担因募集行为而产生的债务和费用;/(2)在基金募集期限届满（确认基金无法成立）后三十日内返还投资者已缴纳的款项，并加计银行同期存款利息。”就该项风险，描述错误的是（　　）。",
            "question": "A. 如果投资者对此项风险有疑问，基金管理人有义务向投资者进一步解释、阐明\nB. 通常情况下，该风险仅适用于基金管理人资信不良的股权投资基金\nC. 相对于特殊风险，该风险揭示事项属于一般风险\nD. 该风险所描述的是基金募集失败所涉风险",
            "answer": "B",
            "explain": "本题考查风险揭示书。A选项说法正确，如果投资者对此项风险有疑问，基金管理人有义务向投资者进一步解释、阐明。"
        }, {
            "title": "关于我国公募证券投资基金和股权投资基金，表述正确的是（　　）。",
            "question": "A. 基金募集方式和基金投资标的均相同\nB. 基金募集方式不同，基金投资标的相同\nC. 基金募集方式和基金投资标的均不同\nD. 基金募集方式相同，基金投资标的不同",
            "answer": "C",
            "explain": "本题考查公募证券投资基金和股权投资基金的区别。"
        },
        {
            "title": "某已投公司进入清算程序，实收资本5亿元，累计亏损4亿元，预计资产变现总值15亿元，A股权投资基金占该公司股权比例20%，持有股权按清算价值法估值为2亿元，下列选项为该公司负债、利息和清算费用正确合计数的是（　　）。",
            "question": "A. 6.5亿元\nB. 5亿元\nC. 5.5亿元\nD. 6亿元",
            "answer": "B",
            "explain": "本题考查清算价值法的估值。公司股权价值的计算公式为公司股权价值=股权占比×股权价值。已知A股权价值为2亿元，占该公司股权比例20%，代入公式公司股权价值=20%×2亿元=0.4亿元。"
        },
        {
            "title": "关于企业价值与股权价值的转换，以下表述错误的是（　　）。",
            "questions": "I. 企业价值既包括核心资产价值，也包括非核心资产价值<br>II. 股权投资基金关注的股权价值为归属于母公司股东的股权价值<br>III. 在进行企业价值和股权价值的转换时，等式中使用的数值是财务报表的账面价值<br>IV. 股权价值为少数股东权益加上归属于母公司股东的股权价值",
            "question": "A. I、III\nB. II、IV\nC. II、III\nD. I、IV",
            "answer": "A",
            "explain": "本题考查企业价值与股权价值的内容。I项说法错误，企业价值是指公司拥有的核心资产运营所产生的价值。"
        },
        {
            "title": "关于股权投资基金管理人、股权投资基金销售机构在宣传推介基金时的行为，表述正确的是（　　）。",
            "questions": "I. 宣传推荐材料不得存在虚假记载，但可以适当缩减基金的风险提示并强调基金的高收益情况<br>II. 宣传资料中可以登载聘请的业内专家所描写的推荐性文字<br>III. 可以在宣传资料中向投资者作出投资本金不受损失的承诺<br>IV. 宣传资料中应当向投资者披露基金的交易结构、收益分配、费用安排、关联交易（如有）等情况",
            "question": "A. I、II、IV\nB. IV\nC. I、II、III、IV\nD. II、III",
            "answer": "B",
            "explain": "本题考查宣传推介禁止性行为。股权投资基金管理人、股权投资基金销售机构在宣传推介过程中不得有以下行为："
        },
        {
            "title": "李先生组织了一批旧友成立了一个创业公司A做新兴业务，李先生邀请其多年的好友王先生作为投资人出资，王先生同意以公司名义出资并和创业投资公司A签署了投资协议。从创业投资的形式上看，王先生的投资属于（　　）。",
            "question": "A. 组织化形式\nB. 早期组织化形式\nC. 杠杆形式\nD. 非组织化形式",
            "answer": "D",
            "explain": "本题考查创业投资的形式。创业投资的形式包括：(1)非组织化形式：非组织化创业投资是指非专业机构和个人分散从事创业投资。"
        },
        {
            "title": "目标企业在进行涉及公司知识产权的交易前，应事先获得投资人的同意，否则可能违背了投资协议中的（　　）。",
            "question": "A. 保密条款\nB. 保护性条款\nC. 优先认购权条款\nD. 回购条款",
            "answer": "B",
            "explain": "本题考查保护性条款。"
        }, {
            "title": "与已分配收益倍数无关的参数是（　　）。",
            "question": "A. 基金因投资项目退出而分配给投资者的款项\nB. 投资者持有基金的年限\nC. 投资者历年向基金支付的出资金额\nD. 投资者收到的基金利润分配",
            "answer": "B",
            "explain": "本题考查已分配收益倍数的内容。已分配收益倍数（DPI）是指截至某一特定时点，投资者已从基金获得的分配金额总和与投资者已向基金缴款金额总和的比率，体现了投资者现金的回收情况。已分配收益倍数的计算公式为：DPI=(D0+D1+D2+...+Dn)/(P0+P1+P2+...+Pn)，其中，D为投资者历年从基金获得的分配额。"
        },
        {
            "title": "股权投资基金甲对目标公司A进行初步尽职调查后判断该公司具有较高投资价值，并计划独家完成对A公司的投资。为了避免在尽职调查和商务谈判阶段A公司再与其他投资机构接触，基金甲可考虑在投资框架协议中加入的条款是（　　）。",
            "question": "A. 优先认购权条款\nB. 保护性条款\nC. 第一拒绝权条款\nD. 排他性条款",
            "answer": "D",
            "explain": "本题考查排他性条款。排他性条款要求目标公司现任股东及其任何任职职员、董事、财务顾问、经纪人或代表公司行事的人在约定的排他期内不得与其他投资机构进行接触，从而保证双方的时间和经济效率。"
        },
        {
            "title": "股权投资基金管理人内部控制应当遵循适时性原则，是指（　　）。",
            "question": "A. 基金管理人应当实时评价内部控制的有效性，并随着有关法律法规的调整和经营战略、方针、理念等内外部环境的变化随时修改或完善\nB. 基金管理人应当不定期评价内部控制的有效性并随着有关法律法规的调整和经营战略、方针、理念等内外部环境的变化随时修改或完善\nC. 基金管理人应当定期评价内部控制的有效性，并随着有关法律法规的调整和经营战略、方针、理念等内外部环境的变化同步进行修改或完善\nD. 基金管理人应当不定期评价内部控制的有效性，并随着有关法律法规的调整和经营战略、方针、理念等内外部环境的变化同步进行修改或完善",
            "answer": "C",
            "explain": "本题考查管理人内部控制的适时性原则。基金管理人应当定期评价内部控制的有效性，并随着有关法律法规的调整和经营战略、方针、理念等内外部环境的变化同步进行修改或完善。该题有两点需要注意：(1)何时评价内部控制的有效性。基金管理人作为一个企业组织，自身就在不断变化当中，针对管理人组织体系内的变化，需要定期评价内部控制的有效性，故A、B、D选项说法错误。"
        },
        {
            "title": "中国证监会对股权投资基金的调查手段，不包括以下哪一项（　　）。",
            "question": "A. 封存可能被转移、解匿或者损毁的文件和资料\nB. 现场检查\nC. 刑事拘留\nD. 调查高管个人证券账户",
            "answer": "C",
            "explain": "本题考查中国证监会事中事后监管的措施。根据《证券投资基金法》及相关配套规范的授权，中国证监会在对股权投资基金进行事中事后监管时，有权采取以下措施：(1)进行现场检查，并要求报送有关的业务资料；(2)进入涉嫌违法行为发生场所调查取证；"
        },
        {
            "title": "关于股权投资基金投资者享有的权利，不包括（　　）。",
            "question": "A. 参与基金资产的投资运作\nB. 查阅或复制公开披露的基金信息资料\nC. 参与分配清算后的剩余基金财产\nD. 按照规定要求召开基金投资者会议",
            "answer": "A",
            "explain": "本题考查基金投资者的权利。基金投资者的权利包括：(1)分享基金财产收益；(2)参与分配清算后的剩余基金财产；"
        },
        {
            "title": "某周期性行业近年景气度不断上升、市场交投活跃，某股权投资基金经过调查研究发现一家技术领先的目标公司，如果采用市盈率估值法进行估值，下列操作可以帮助基金防范周期性行业估值风险的是（　　）。",
            "question": "A. 主观调整目标公司的可比倍数\nB. 参考周期内平均可比倍数\nC. 剔除可比公司的异常值\nD. 取特定时刻的可比倍数",
            "answer": "B",
            "explain": "本题考查市盈率倍数法的影响因素及选取标准。市盈率(P/E)倍数反映了一家公司的股权价值相对其净利润的倍数。企业净利润和市盈率易受经济周期的影响，两种因素相互叠加会导致周期型企业的估值在一个经济周期内呈现大幅起落的特征。"
        }, {
            "title": "关于公司申请在全国中小企业股份转让系统挂牌条件，正确的是（　　）。",
            "question": "A. 公司自行向全国中小企业股份转让系统公司申请挂牌\nB. 《公司法》(2006年1月1日)前设立的股份公司，需取得证监会的批准文件\nC. 有限责任公司按照账面净资产值折股整体变更为股份有限公司的，存续时间可以从有限责任公司成立之日起计算\nD. 公司应至少存续三个完整的会计年度",
            "answer": "C",
            "explain": "本题考查股份有限公司申请股票在全国中小企业股份转让系统挂牌的要求。股份有限公司申请股票在全国中小企业股份转让系统挂牌，不受股东所有制性质的限制，不限于高新技术企业，但应当符合下列条件：(1)依法设立且存续满两年，有限责任公司按账面净资产值折股整体变更为股份有限公司的，存续时间可以从有限责任公司成立之日起计算。"
        },
        {
            "title": "被投资企业境内IPO市场包括（　　）。",
            "questions": "I. 主板<br>II. 中小企业板<br>III. 创业板<br>IV. 全国股转系统",
            "question": "A. I、II、III、IV\nB. I、II、III\nC. I、II、IV\nD. I、III、IV",
            "answer": "B",
            "explain": "本题考查上市退出的主要市场。"
        },
        {
            "title": "按现行税法规定，对于有限合伙型基金，自然人投资者的个人所得税代扣代缴主体为（　　）。",
            "question": "A. 自然人投资者\nB. 基金托管人\nC. 有限合伙型基金\nD. 有限合伙型基金的其他合伙人",
            "answer": "C",
            "explain": "本题考查合伙型基金的所得税。C选项符合题意，有限合伙型基金通常根据税法的相关规定，由基金代扣代缴自然人投资者的个人所得税。"
        },
        {
            "title": "某有限责任公司型基金有50名股东，其中一名股东拟对外转让股权，下述可以接受转让的对象是（　　）。",
            "question": "A. 两名自然人\nB. 未备案的一家合伙企业\nC. 未备案的一只信托（契约）型基金\nD. 一家保险公司",
            "answer": "D",
            "explain": "本题考查合格投资者人数的核查。投资者转让基金份额的，受让人应当为合格投资者且基金份额受让后投资者人数应当符合合格投资者人数限制规定。有限责任公司型基金人数不超过50人，所以股东只能向一位投资者转让。"
        },
        {
            "title": "注册在境内的企业赴境外直接上市的方式路径相对简单，但由于严格的财务要求，此模式更适用于（　　）。",
            "question": "A. 初创民营企业\nB. 小型民营企业\nC. 大型国有企业\nD. 小型国有企业",
            "answer": "C",
            "explain": "本题考查境外直接上市的适用对象。"
        },
        {
            "title": "在对股权基金项目退出收益进行分配时，按分配的时间先后顺序为（　　）。",
            "questions": "I. 门槛收益<br>II. 返还投资成本<br>III. 根据“二八模式”按比例分配的超额收益<br>IV. 追赶机制下向管理人分配超额收益",
            "question": "A. II、I、IV、III\nB. II、III、I、IV\nC. II、I、III、IV\nD. I、III、IV、II",
            "answer": "A",
            "explain": "本题考查股权基金项目退出收益分配的顺序。"
        }, {
            "title": "关于信托（契约）型股权投资基金的份额转让表述错误的是（　　）。",
            "question": "A. 若基金份额持有人转让份额，一般须经其他基金份额持有人过半数通过\nB. 基金份额持有人享有依法转让基金份额的权利\nC. 基金份额持有人转让份额的，份额受让人必须是合格投资者\nD. 基金份额转让完成后，信托（契约）型股权基金的合格投资者人数不得超过200人",
            "answer": "A",
            "explain": "本题考查信托（契约）型股权投资基金的份额转让。"
        },
        {
            "title": "关于尽职调查，以下表述错误的是（　　）。",
            "question": "A. 尽职调查的主要程序包括团队组建、资料收集及研读、现场调研、报告撰写及报告复核\nB. 尽职调查小组一般由基金管理人的投资管理人员组成，也可能涉及相关中介机构\nC. 尽职调查报告复核是股权投资机构内部的自我监督机制，无需复核第三方中介机构出具的尽职调查报告\nD. 资料调查与现场调研是相互依存、相互补充、相互印证的，都是尽职调查必不可少的环节",
            "answer": "C",
            "explain": "本题考查尽职调查的主要程序。A选项说法正确，尽职调查的主要程序包括计划制订与团队组建、二手资料收集与研读、企业现场调研、撰写尽职调查报告和进行内部复核。B选项说法正确，尽职调查小组一般由基金管理人的投资管理人员组成，也可能涉及相关中介机构。"
        },
        {
            "title": "企业上市后股权锁定期设置的目的在于（　　）。",
            "question": "A. 发行企业主动提升投资者信心\nB. 提高退出实现的收益率水平\nC. 保护中小投资者\nD. 提高退出节奏的计划性",
            "answer": "C",
            "explain": "本题考查对于企业上市设置锁定期的目的。A选项不符合题意，锁定期分为强制锁定和自愿锁定。强制锁定是指法律法规或交易所规则规定的关于股份锁定的规则。例如，我国《公司法》规定"
        },
        {
            "title": "基金信息披露义务人应当将基金各项重要事项进行全面、完整的披露，股权基金的信息披露包含以下哪些内容（　　）。",
            "questions": "I.基金合同、托管协议<br>II.基金募集推介材料<br>III.基金所投项目的盈利预测<br>IV.基金的投资情况、收益分配情况、资产负债表情况、基金主要财务指标",
            "question": "A. I、II、III、IV\nB. I、II、III\nC. II、III、IV\nD. I、II、IV",
            "answer": "D",
            "explain": "本题考查信息披露的内容。"
        },
        {
            "title": "根据《公司法》的相关规定，设立有限责任公司，应当具备的条件有（　　）。",
            "questions": "I.股东符合法定人数<br>II.有符合公司章程规定的全体股东认缴的出资额<br>III.股东共同制定公司章程<br>IV.建立符合有限责任公司要求的组织机构",
            "question": "A. I、II\nB. I、II、III\nC. I、II、IV\nD. I、II、III、IV",
            "answer": "D",
            "explain": "本题考查公司型基金的设立。"
        },
        {
            "title": "基金管理人甲公司管理的A基金为一只专注初创期企业投资的合伙型基金，受到投资人缴入资本合计2亿元，以前年度尚未对投资人进资的Y公司在本年度对A基金所持股权进行回购，回购款合计1200万元，已全款支付给A基金。A基金就收到的回购款金额对投资人进行基金本年度出售其所持Z公司的股权，实现投资收益500万元，扣除基金相关费用后，基金本年合计实现净收益300万元，年末基金净值以上材料，回答以下题目。截至本年年末，A基金的总收益倍数为（　　）。",
            "question": "A. 1.325\nB. 0.06\nC. 1.335\nD. 1.31",
            "answer": "D",
            "explain": "本题考查总收益倍数。"
        }, {
            "title": "股权投资基金管理人管理可能导致利益输送或者利益冲突的不同基金的，应当建立防范（　　）。",
            "question": "A. 利益输送和利益冲突\nB. 利益共享和利益冲突\nC. 利益共享和利益输送\nD. 利益分配和利益输送",
            "answer": "A",
            "explain": "本题考查防范利益冲突要求。股权投资基金管理人管理可能导致利益输送或者利益冲突的不同基金的，应当建立防范利益输送和利益冲突的机制。"
        },
        {
            "title": "在我国，'私募股权投资基金'的准确含义应为（　　）。",
            "question": "A. 股权基金\nB. 私人投资基金\nC. 私募类私人股权投资基金\nD. 股指基金",
            "answer": "C",
            "explain": "本题考查股权投资基金概念。在我国，目前股权投资基金尚只能以非公开方式募集。因此，在我国当前的法律和监管规则下，一般所称'私募股权投资基金'的私人股权投资基金。"
        },
        {
            "title": "有关拖售权与随售权，下列表述正确的是（　　）。",
            "question": "A. 拖售权的交易价格以股权投资基金与第三方协商确定的价格为准\nB. 随售权可以保证投资者作为不参与企业实际经营管理的小股东，同样可以按照其和第三方协商确定的价格及时点决定退出，且不会受到管理团队的拒绝\nC. 拖售权是股权投资基金微强行进入其他股东与第三方的交易\nD. 相比拖售权，随售权赋予股权投资基金更大的权利，使基金作为少数股东仍然享有决定公司转让的权利",
            "answer": "A",
            "explain": "本题考查施售权条款。A选项正确，C选项错误，随售权是股权投资基金微强行进入其他股东与第三方的交易，交易价格以其他股东与第三方协商确定的价格为准。"
        },
        {
            "title": "某股权投资基金拟投资目标公司B药业，在审阅其财务报表时，重点关注的内容不包括（　　）。",
            "question": "A. 收入确认原则变得更为激进\nB. 参股子公司的应收账款情况改善\nC. 经营性现金流持续为负\nD. 商誉计提较大金额减值",
            "answer": "B",
            "explain": "本题考查财务尽职调查中的财务报告及相关财务资料。A选项，财务报表的利润表重点核查收入确认、销售成本、期间费用核算的规范性。故A选项正确。"
        },
        {
            "title": "下列关于单只基金的投资者人数限制的说法，错误的是（　　）。",
            "questions": "I.契约型股权投资基金根据《证券投资基金法》的规定，投资者人数不得超过200人<br>II.公司型股权投资基金根据《公司法》的规定，采取有限责任公司形式的股权投资基金，投资者人数不得超过200人<br>III.合伙型股权投资基金根据《合伙企业法》的规定，投资者人数不得超过50人（含普通合伙人）<br>IV.公司型股权投资基金根据《公司法》的规定，采取股份有限公司形式的股权投资基金，投资者人数不得超过200人",
            "answer": "B",
            "explain": "本题考查合格投资者。股权投资基金应当向合格投资者募集，单只股权投资基金的投资者人数累计不得超过《证券投资基金法》《公司法》《合伙企业法》等法律规定的特定数量，拥有有限责任公司型和有限合伙型股权投资基金投资者人数不超过50人，股份有限公司和信托（契约）型股权投资基金投资者人数不超过200人。"
        },
        {
            "title": "中国证监会对股权投资基金的监管职责范围不包括（　　）。",
            "question": "A. 负责股权投资基金的信息统计和风险监测工作\nB. 制定监管股权投资基金的规则、细则\nC. 组织对股权投资基金开展监督检查\nD. 承担股权投资基金的备案工作",
            "answer": "D",
            "explain": "本题考查中国证监会对股权投资基金的监管职责。(1)拟定监管私募投资基金的规则、实施细则；(B选项不符合题意)"
        }, {
            "title": "根据中国证券投资基金业协会的分类标准，与企业非公开交易私人股权投资相关的基金类型有（　　）。",
            "questions": "I. 创业投资基金<br>II. 股权投资基金<br>III. 创业投资基金类FOF基金<br>IV. 股权投资基金类FOF基金",
            "question": "A. II、III、IV\nB. III、IV\nC. I、II、III、IV\nD. II、III",
            "answer": "C",
            "explain": "本题考查对股权投资基金的基本要求。"
        },
        {
            "title": "境外股权投资基金向境内目标公司投资需要完成相关审批或备案程序，审批机关不包括（　　）。",
            "question": "A. 外汇局\nB. 商务部\nC. 工商总局\nD. 国家发展改革委",
            "answer": "C",
            "explain": "本题考查境外股权投资基金向境内目标公司的投资。"
        },
        {
            "title": "以下有关公司型股权投资基金的清算顺序的说法中，正确的是（　　）。",
            "question": "A. 缴纳所欠税款、支付清算费用、清偿公司债务、分配剩余财产\nB. 缴纳所欠税款、清偿公司债务、支付清算费用、分配剩余财产\nC. 清偿公司债务、支付清算费用、缴纳所欠税款、分配剩余财产\nD. 支付清算费用、缴纳所欠税款、清偿公司债务、分配剩余财产",
            "answer": "D",
            "explain": "本题考查公司型股权投资基金的清算退出。"
        },
        {
            "title": "其他条件不变，以下引起基金资产净值(NAV)增加的选项是（　　）。",
            "question": "A. 基金应承担的负债的增加\nB. 基金货币资金的减少\nC. 基金已投项目增公允价值的增加\nD. 基金应承担的管理费的增加",
            "answer": "C",
            "explain": "本题考查基金资产净值。"
        },
        {
            "title": "关于锁定期的表述，错误的是（　　）。",
            "question": "A. 锁定期的设置通常是为了保护中小投资者的利益，防止“内部人”利用信息优势获得不正当利益\nB. 强制锁定是根据法律法规或公司章程规定的有关股份锁定的规则\nC. 自愿锁定是指在强制锁定的基础上，为了提升投资者信心，公司的实际控制人、高管、董事、监事、控股股东等自愿承诺在一定时期内持有的上市公司的股份\nD. 锁定期分为强制锁定和自愿锁定两种",
            "answer": "B",
            "explain": "本题考查锁定期的内容。"
        },
        {
            "title": "关于股权投资基金募集机构的责任和义务，以下表述正确的是（　　）。",
            "question": "A. 募集机构自募集完成后对基金投资者投向基金的资金与财产安全承担责任与义务\nB. 尊重机构从募集阶段开始即对基金投资者投向基金的资金与财产承担责任与义务\nC. 中国证券投资基金业协会对基金管理人已在协会备案的基金财产安全承担责任与义务\nD. 基金投资者在募集阶段结束后仍对其投向基金的资金与财产承担责任与义务，基金管理人仅承担管理义务",
            "answer": "B",
            "explain": "本题考查股权投资基金募集机构的责任和义务。"
        },
        {
            "title": "某股权投资基金管理人设立并管理一只有限合伙型股权投资基金，该基金主要投资初创科技型企业，基金管理人在基金登记备案时，必须报送的信息或材料不包括（　　）。",
            "question": "A. 营业执照正副本及复印件\nB. 管理人过往投资业绩\nC. 主要投资方向",
            "answer": "B",
            "explain": "本题考查基金备案的内容。"
        }, {
            "title": "假设某股权投资基金已投实缴规模2亿元门槛收益率为8%，基金管理人收取20%的收益，且设追赶机制。该基金已完成全部投资，共投资A和B两个公司。2年后，顺利完成A公司的退出，退出后回收现金金额为1.1亿元，并已全额向投资者分配；同时，B公司最近一年净利润为9000万元，最新一轮交易按照息税前利润的6倍进行估值，所得税税率为25%，公司债务余额为1亿元，利息为每年1000万元，交易完成后该股权基金占B公司股比稀释至20%。",
            "questions": "(1)按照企业价值/息税前利润倍数法，基金所持有公司的股权对应估值为（　　）。\nA. 7.8亿元\nB. 1.56亿元\nC. 1.36亿元\nD. 1.08亿元",
            "answer": "C",
            "explain": "本题考查息税前利润倍数。"
        },
        {
            "title": "假设某股权投资基金已投实缴规模2亿元门槛收益率为8%，基金管理人收取20%的收益，且设追赶机制。该基金已完成全部投资，共投资A和B两个公司。2年后，顺利完成A公司的退出，退出后回收现金金额为1.1亿元，并已全额向投资者分配；同时，B公司最近一年净利润为9000万元，最新一轮交易按照息税前利润的6倍进行估值，所得税税率为25%，公司债务余额为1亿元，利息为每年1000万元，交易完成后该股权基金占B公司股比稀释至20%。",
            "questions": "(2)假设目的该基金的资产净值为2.1亿元，则该基金的总收益倍数为（　　）。\nA. 1.05\nB. 3.2\nC. 1.6\nD. 0.55",
            "answer": "C",
            "explain": "本题考查总收益倍数。"
        },
        {
            "title": "增资前甲公司注册资本100万元，甲公司前一年度经审计的营业收入12亿元，净利润4000万元，年末净资产1.5亿元。依据股权投资基金拟出资1亿元，增资甲公司，获得20%股权。按此投资方案实际投资后，甲公司注册资本将变为（　　）万元。",
            "question": "A. 125\nB. 30000\nC. 120\nD. 50000",
            "answer": "A",
            "explain": "本题考查基金估值。投资1亿后获得20%的股权，则企业投后估值为：1亿/20%=5亿元。投资前估值为5-1=4亿元，注册资本占投资前估值比例为4/4亿元。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/smgq-1.js